import { ConfigData } from 'types/interfaces';

const config: ConfigData = {
  ID: 'TAX_STEP',
  STEP_JOINT_ID: 'TAX_STEP_JOINT',
  SIDEBAR_MENU: true,
  PROGRESS_BAR: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};

export default config;
